// icon:locate-fixed | Lucide https://lucide.dev/ | Lucide
import * as React from "react";

function IconLocateFixed(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="2.5em"
      width="2.5em"
      {...props}>
      <path d="M2 12h3M19 12h3M12 2v3M12 19v3" />
      <path d="M19 12 A7 7 0 0 1 12 19 A7 7 0 0 1 5 12 A7 7 0 0 1 19 12 z" />
      <path d="M15 12 A3 3 0 0 1 12 15 A3 3 0 0 1 9 12 A3 3 0 0 1 15 12 z" />
    </svg>
  );
}

export default IconLocateFixed;
